module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"email":"E-Mail","storage":"Speicherplatz","logout":"Abmelden","projects":"Projekte","devices":"Geräte","users":"Nutzer"}}')
  delete Component.options._Ctor
}
